import {isValidPhoneNumber,validatePhoneNumberLength} from "libphonenumber-js"

export const validateCharecters = function (data) {
  var regex = /^([a-zA-Z ]+)$/;
  return regex.test(data);
};

export const validateIntegers = function (data) {
  var regex = /^([0-9]+)$/;
  return regex.test(data);
};

export const validateEmail = function (data) {
  var regex = /^((([a-zA-Z]|[0-9])|([-]|[_]|[.])){1,})+[@](([a-zA-Z0-9])|([-]|[.])){2,}[.]((([a-zA-Z0-9]){2,})|(([a-zA-Z0-9]){2,}[.]([a-zA-Z0-9]){2,}))$/;
    return regex.test(data);
};

export const validateDob = function (data) {
  var regex = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;
  return regex.test(data);
};

export const validateDcotorDob = function (date) {
  let dob = new Date(date);
  let now = new Date();
  let max_date = now.setFullYear(now.getFullYear() - 21);
  // let age_dt = new Date(month_diff);
  // let year = age_dt.getUTCFullYear();
  // let age = Math.abs(year - 1970);

  // return age > 21
  return dob.valueOf() <= max_date.valueOf();
}
export const validateDate = function (dob) {
  return new Date(dob).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
}
export const validateSrvstrtDt = function (data) {
  var regex = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g;
  return regex.test(data);
};
export const validatePhone = function (data) {
  var regex = /^([6-9][0-9]{9})$/;
  return regex.test(data);
};

export const validateIntlPhone = function (data) {
  var regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  return regex.test(data);
};

export const valPnBoCc = function(phoneNumber) {
	// const fullPhoneNumber = `+${countryCode}${phoneNumber}`;
    const isValid = isValidPhoneNumber(phoneNumber);
	return isValid;
}

export const validateContactNumber=function(phoneNumber, countryCode) {
	let fullPhoneNumber =  `${countryCode}${phoneNumber}`;
	fullPhoneNumber=fullPhoneNumber.startsWith("+") ? fullPhoneNumber :("+" + fullPhoneNumber)

	const isValid = isValidPhoneNumber(fullPhoneNumber.toString());
	const validateLength=validatePhoneNumberLength(fullPhoneNumber);

	if(validateLength === "TOO_SHORT"){
		return "Phone number is too short"
	}
	else if(validateLength === "TOO_LONG"){
		return "Phone number is too long"
	}
	else if(!isValid){
		return "Please enter valid phone number"
	}
	else{
		return ""
	}
}

export const validateLicense = function (data) {
  var regex = /^[a-zA-Z0-9]*$/
  // var regex = /^[a-zA-Z0-9\-_]{0,40}$/
  return regex.test(data);
};


export const validatePassword = (data) => {
  var regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  return regex.test(data)
}
export const validateLetters = (data) => {
  var regex = /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/;
  return regex.test(data);
}

export const validateExtraAlphaNumSpecial = function (data) {
  let re = /^[a-zA-Z0-9!@#$%^&*()_+=:;'",./`~|\\\s-]+$/;
  return re.test(data);
};

export const validatePincode = (data) => {
  var regex = /^[1-9]\d*$/;
  return regex.test(data);
}

export const validateYoutubeurl = (url) => {
  let regex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
  let match = url.match(regex);
  return match && match[2].length === 11;
}

export const validateVimeourl = (url) => {
  let regex = /https:\/\/vimeo.com\/\d{8,9}(?=\b|\/)/;
  return regex.test(url);
}

export const validateIsNotempty = (data) => {
  return data && data.trim() !== "";
}

export const validateKeys= (data) => {
  let regex = /^[A-Za-z0-9_-]\S+$/
  return regex.test(data);
}

export const validateConfigName = (data) => {
  let regex = /^[A-Za-z]+([ A-Za-z'-]+)*$/;
  return regex.test(data);
}

export const validateConfigCode = (data) => {
  let regex = /^[a-zA-Z0-9]*$/
  return regex.test(data);
}

export const validateConfigDesc = (data) => {
  let regex = /^[A-Za-z0-9]\$+$/
  return regex.test(data);
}

export const validateDomain = (data) => {
  let regex = /^([a-z]+)$/;
  return regex.test(data);
}
export const validateServerAddress = (address) => {
  // Basic validation for server address (e.g., must contain a dot and no spaces)
  const serverAddressPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return serverAddressPattern.test(address);
};

export const validatePortNumber = (port) => {
  // Port number should be an integer between 1 and 65535
  const portPattern = /^\d+$/;
  const portNum = parseInt(port, 10);
  return portPattern.test(port) && portNum > 0 && portNum <= 65535;
};
export const validateGatewayUrl = (url) => {
  const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
  return urlPattern.test(url);
};
export const validateMessageKey = (messageKey) => {
  const messageKeyPattern = /^[A-Za-z0-9]+$/;
  return messageKeyPattern.test(messageKey);
};
export const validateTemplateId = (templateId) => {
  const templateIdPattern = /^[A-Za-z0-9]+$/;
  return templateIdPattern.test(templateId);
};

export function tryParseJSONObject(jsonString) {
  try {
    let o = JSON.parse(jsonString);
    if (o && typeof o === "object") {
      return o;
    }
  }
  catch (e) {
    return jsonString;
  }
  return jsonString;
};

